interface Props {
  fill?: string;
  className?: string;
}

const Bookmark = ({ className, fill = '#1a1818' }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
  >
    <path fill={fill} d="M18 24l-6-5.269-6 5.269v-24h12v24z" />
  </svg>
);

export default Bookmark;
